import Vue from 'vue'
import router from '../../router'
import moment from 'moment'
import { wtPromoGroups } from '@/walkthroughs/wtData'
import pagingMap from '@/helpers/pagination'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

function getPromoGroup(state, payload) {
    return state.promoGroups.find(group => group.id === payload.groupId)
}
function getSelectedPromoGroup(state, payload) {
    return state.selectedPromoGroups.find(group => group.id === payload.groupId)
}
function getPromoGroupPromo(state, payload) {
    const searchedGroup = state.promoGroups.find(
        group => group.id === payload.groupId
    )
    return searchedGroup?.promos.find(el => el.id === payload.promoId)
}

function getSelectedPromoGroupPromo(state, payload) {
    const searchedGroup = state.selectedPromoGroups.find(
        group => group.id === payload.groupId
    )
    return (
        searchedGroup &&
        searchedGroup.promos.find(el => el.id === payload.promoId)
    )
}
export const promoGroups = {
    state: {
        status: 'idle',
        promoGroups: null,
        promosLoad: {
            initial: 2,
            big: 100
        },
        sortOptions: [
            {
                query: 'position,promo_published_at',
                label: 'Polecane'
            },
            {
                query: 'promo_published_at',
                label: 'Ostatnio dodane'
            },
            {
                query: 'id',
                label: 'ID'
            },
            {
                query: 'name',
                label: 'Nazwa grupy'
            }
        ],
        sort: {
            by: 'position,promo_published_at',
            direction: 'desc'
        },
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 5,
            totalRecords: null
        },
        selectedPromoGroups: [],
        currentPromoGroup: null,
        walkthroughModalPromoAcceptStep: 1,
        allGroupAttachmentsStatus: 'idle',
        unloadedWeightPromos: [],
        localCodesValidation: false,
        count: {
            'promo-list': undefined,
            'promo-yours': undefined,
            'promo-finished': undefined
        },
        selectedNoEansPromos: [],
        activePromosDownloadStatus: 'idle'
    },
    mutations: {
        SET_WALKTHROUGH_MODAL_PROMO_ACCEPT_STEP(state, payload) {
            state.walkthroughModalPromoAcceptStep = payload
        },
        SET_PROMO_SELECTED_SHOPS(state, payload) {
            const promoGroups = JSON.parse(
                JSON.stringify(state.selectedPromoGroups)
            )
            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromo = promoGroup.promos.find(
                promo => promo.id === payload.promoId
            )

            if (payload.equalPrices) {
                selectedPromo.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx
                ] = payload.subscriptions
            } else {
                selectedPromo.subscriptions = payload.subscriptions
            }

            state.selectedPromoGroups = promoGroups
        },
        SET_PROMOGROUPS_STATUS(state, payload) {
            state.status = payload
        },
        SET_PROMOGROUPS(state, payload) {
            state.promoGroups = payload
        },
        SET_PROMOGROUPS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_PROMOGROUP_PROMOS(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return
            if (payload.resetGroup) searchedGroup.promos = []
            searchedGroup.promos.push(
                ...payload.promos.map(el => {
                    return {
                        ...el,
                        selected: false
                    }
                })
            )
        },
        SET_PROMOGROUP(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return

            Object.assign(searchedGroup, payload.group)
        },
        SET_PROMOGROUP_STATUS(state, payload) {
            const loadingSelectedPromoIds = payload.loadingSelectedPromoIds
                ? payload.loadingSelectedPromoIds
                : false
            const searchedGroup = getPromoGroup(state, payload)
            if (searchedGroup) {
                searchedGroup.status = payload.status
                Vue.set(
                    searchedGroup,
                    'loadingSelectedPromoIds',
                    loadingSelectedPromoIds
                )
            }

            const selectedSearchedGroup = getSelectedPromoGroup(state, payload)
            if (selectedSearchedGroup) {
                selectedSearchedGroup.status = payload.status
                Vue.set(
                    selectedSearchedGroup,
                    'loadingSelectedPromoIds',
                    loadingSelectedPromoIds
                )
            }
        },
        SET_SELECTED_PROMOGROUP_PAGINATION(state, payload) {
            const searchedGroup = getSelectedPromoGroup(state, payload)
            if (!searchedGroup) return
            searchedGroup.pagination = payload.pagination
        },
        SET_PROMOGROUP_PAGINATION(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return
            searchedGroup.pagination = payload.pagination
        },
        RESET_PROMOGROUP_PRODUCTS_PAGINATION(state, payload) {
            let searchedPromo
            if (payload.selected) {
                searchedPromo = getSelectedPromoGroupPromo(state, payload)
            } else {
                searchedPromo = getPromoGroupPromo(state, payload)
            }

            if (!searchedPromo) return
            Vue.set(searchedPromo, 'productsPagination', null)
        },
        SET_PROMOGROUP_PROMO_PRODUCTS(state, payload) {
            const searchedPromo = getPromoGroupPromo(state, payload)
            const searchedSelectedPromo = getSelectedPromoGroupPromo(
                state,
                payload
            )

            if (searchedPromo && !payload.selectedGroups) {
                if (payload.reset) {
                    searchedPromo.products = []
                }
                if (payload.products?.length) {
                    const searchedProductIds = new Set(
                        searchedPromo.products.map(e => e.id)
                    )

                    payload.products.forEach(product => {
                        if (!searchedProductIds.has(product.id)) {
                            searchedPromo.products.push(product)
                        }
                    })
                }
                if (payload.productsSetData?.length) {
                    let { reset, productSetId, productsSetData } = payload

                    if (!searchedPromo.product_sets.length) {
                        searchedPromo.product_sets = JSON.parse(
                            JSON.stringify(productsSetData)
                        )
                        reset = true
                    }

                    searchedPromo.product_sets.forEach(set => {
                        const pSet = JSON.parse(
                            JSON.stringify(
                                productsSetData.find(s => s.id === set.id)
                            )
                        )

                        if (
                            pSet &&
                            (!productSetId || productSetId === set.id)
                        ) {
                            if (reset) {
                                set.product_set_dict_products = []
                            }

                            set.product_set_dict_products.push(
                                ...pSet.product_set_dict_products
                            )
                        }
                    })
                }

                if (payload.pagination) {
                    Vue.set(
                        searchedPromo,
                        'productsPagination',
                        payload.pagination
                    )
                }
            }

            if (searchedSelectedPromo && payload.selectedGroups) {
                if (payload.pagination) {
                    Vue.set(
                        searchedSelectedPromo,
                        'productsPagination',
                        payload.pagination
                    )
                }
                if (payload.products?.length) {
                    if (payload.reset) {
                        searchedSelectedPromo.products = []
                    }
                    const searchedProductIds = new Set(
                        searchedSelectedPromo.products.map(e => e.id)
                    )
                    payload.products.forEach(product => {
                        if (!searchedProductIds.has(product.id)) {
                            searchedSelectedPromo.products.push(product)
                        }
                    })
                }

                if (payload.productsSetData?.length) {
                    let { reset, productSetId, productsSetData } = payload

                    if (!searchedSelectedPromo.product_sets.length) {
                        searchedSelectedPromo.product_sets = JSON.parse(
                            JSON.stringify(productsSetData)
                        )
                        reset = true
                    }

                    searchedSelectedPromo.product_sets.forEach(set => {
                        const pSet = JSON.parse(
                            JSON.stringify(
                                productsSetData.find(s => s.id === set.id)
                            )
                        )

                        if (
                            pSet &&
                            (!productSetId || productSetId === set.id)
                        ) {
                            if (reset) {
                                set.product_set_dict_products = []
                            }

                            set.product_set_dict_products.push(
                                ...pSet.product_set_dict_products
                            )
                        }
                    })
                }
            }
        },
        SET_PROMOGROUP_PROMO_PRODUCTS_STATUS(state, payload) {
            const promo = getPromoGroupPromo(state, payload)
            if (promo) {
                Vue.set(promo, 'productsStatus', payload.status)
                Vue.set(
                    promo,
                    'fetchingSetId',
                    payload.productSetId ? payload.productSetId : null
                )
            }

            const selectedPromo = getSelectedPromoGroupPromo(state, payload)
            if (selectedPromo) {
                Vue.set(selectedPromo, 'productsStatus', payload.status)
                Vue.set(
                    selectedPromo,
                    'fetchingSetId',
                    payload.productSetId ? payload.productSetId : null
                )
            }
        },
        SET_PROMOGROUPS_SORT(state, payload) {
            state.sort = payload
        },
        SELECT_PROMOGROUP(state, payload) {
            state.selectedPromoGroups = payload
        },
        SET_PROMOGROUP_MERCHANTS(state, payload) {
            const searchedGroup = getSelectedPromoGroup(state, payload)
            searchedGroup.merchantIds = payload.merchantIds
        },
        SET_ALL_GROUP_ATTACHMENTS_STATUS(state, payload) {
            state.allGroupAttachmentsStatus = payload
        },
        SET_UNLOADED_WEIGHT_PROMOS(state, payload) {
            state.unloadedWeightPromos = payload
        },
        SET_LOCALCODES_VALIDATION(state, payload) {
            state.localCodesValidation = payload
        },
        SET_SELECTED_GROUPS_SELECTWHOLEGROUP(state, payload) {
            state.selectedPromoGroups.forEach(el => {
                el.selectWholeGroup = payload
            })
        },
        SET_PROMOGROUPS_COUNT(state, payload) {
            state.count = { ...state.count, ...payload }
        },
        RESET_PROMOGROUPS_COUNT(state) {
            state.count = {
                'promo-list': null,
                'promo-yours': null,
                'promo-finished': null
            }
        },
        SET_SELECTED_NO_EANS_PROMOS(state, payload) {
            state.selectedNoEansPromos = payload
        },
        SET_ACTIVE_PROMOS_DOWNLOAD_STATUS(state, payload) {
            state.activePromosDownloadStatus = payload
        }
    },
    actions: {
        setGroupPromotionEqualPrice({ state, commit }, payload) {
            const promo = getSelectedPromoGroupPromo(state, payload)

            const priceGroups =
                promo.subscriptionsEqualPrices &&
                promo.subscriptionsEqualPrices.priceGroups.length
                    ? promo.subscriptionsEqualPrices.priceGroups
                    : [promo.subscriptions]
            promo.subscriptionsEqualPrices = {
                equalPrices: payload.val,
                priceGroups: priceGroups
            }
        },
        setGroupPromoSubscriptions({ state, commit, getters }, payload) {
            const searchedGroupMerchants = getSelectedPromoGroup(state, payload)
                ?.merchantIds

            const selectedGroups = getters.getSelectedPromoGroupsJson
            const selectedPromo = selectedGroups
                .find(el => el.id === payload.groupId)
                ?.promos.find(el => el.id === payload.promoId)

            const promoGroups = getters.getPromoGroupsJson
            const promo = promoGroups
                .find(el => el.id === payload.groupId)
                ?.promos.find(el => el.id === payload.promoId)
            const promos = [promo, selectedPromo]

            const setSubscription = (subscription, promo) => {
                let checked = subscription.checked ?? true
                if (payload.copyOnlySelectedSubs && !subscription.checked) {
                    checked = false
                }
                if (searchedGroupMerchants && payload.firstTimeLoad) {
                    const merchant = searchedGroupMerchants.find(
                        merchant => merchant.id === subscription.merchant_id
                    )
                    checked = merchant.selected
                }
                const sub = {
                    ...subscription,
                    checked
                }

                if (promo.products) {
                    sub.products = promo.products.map(pProduct => {
                        const sProduct = subscription.products?.find(
                            el => el.id === pProduct.id
                        )
                        return {
                            ...pProduct,
                            productName: pProduct.dict_product.name,
                            productId: pProduct.id,
                            productPrice: sProduct
                                ? sProduct.productPrice
                                : null,
                            alternativeEan: sProduct
                                ? sProduct.alternativeEan
                                : null,
                            productMaxPrice: pProduct.maximum_promotional_price
                        }
                    })
                }

                if (promo.product_sets) {
                    sub.product_sets = promo.product_sets.map(item => {
                        const sProduct = subscription.product_sets?.find(
                            el => el.id === item.id
                        )

                        return {
                            id: item.id,
                            price: sProduct ? sProduct.price : null,
                            maxPrice: item.price
                        }
                    })
                }

                return sub
            }

            promos.forEach((promo, idx) => {
                if (!promo) return
                if (payload.firstTimeLoad) {
                    promo.firstTimeLoad = false
                }
                promo.subscriptions = promo.subscriptions.map(el => {
                    return setSubscription(el, promo)
                })

                if (payload.firstTimeLoad) {
                    const isWeight = getters.isWeight(promo.type)
                    const val = !isWeight

                    promo.subscriptionsEqualPrices = {
                        equalPrices: val,
                        priceGroups: [promo.subscriptions]
                    }

                    if (isWeight) {
                        promo.subscriptionsEqualPrices.equalPrices = false
                    }
                } else {
                    promo.subscriptionsEqualPrices.priceGroups =
                        promo.subscriptionsEqualPrices.priceGroups.map(
                            group => {
                                return group.map(el => {
                                    return setSubscription(el, promo)
                                })
                            }
                        )
                }
            })

            if (promo) {
                commit('SET_PROMOGROUPS', promoGroups)
            }
            if (selectedPromo) {
                commit('SELECT_PROMOGROUP', selectedGroups)
            }
        },
        clearSelectedPromoGroups({ commit, state }) {
            state.selectedPromoGroups.forEach(group => {
                group.promos.forEach(promo =>
                    commit('RESET_PROMOGROUP_PRODUCTS_PAGINATION', {
                        groupId: group.id,
                        promoId: promo.id,
                        selected: true
                    })
                )
            })
            commit('SELECT_PROMOGROUP', [])
        },

        async fetchPromoGroups({ state, commit, dispatch, getters }, payload) {
            const { paramsGroups: params, pagination, noCancel } = payload

            const res = await this.$api.get('promo_groups', {
                params: {
                    per: pagination?.per,
                    page: pagination?.page,
                    ...params
                },
                config: {
                    noCancel: noCancel !== undefined ? noCancel : true
                }
            })

            if (res.data?.data) {
                res.data.data = res.data.data.map(el => {
                    return {
                        ...el,
                        pagination: null,
                        promos: [],
                        selectWholeGroup: false,
                        selectWholeGroupButtonEnable: true,
                        groupButtonTooltipInfo: null,
                        status: 'idle'
                    }
                })
            }

            return res
        },

        async loadPromoGroups({ state, commit, dispatch, getters }, payload) {
            if (getters.getWalkthroughActive) {
                commit('SET_PROMOGROUPS', wtPromoGroups)
                commit('SET_PROMOGROUPS_PAGINATION', {
                    perPage: 5,
                    page: 1,
                    totalPages: 1,
                    totalRecords: 2
                })
                return
            }

            commit('SET_PROMOGROUPS_STATUS', 'loading')

            // Set per and page for query params
            const per =
                Number(router.currentRoute.query.show) ||
                Number((await this.$storage.getItem('perPage'))?.promotions) ||
                state.pagination.perPage

            const page =
                Number(router.currentRoute.query.page) || state.pagination.page

            // Update pagination in local storage
            const updatedPagination = state.pagination
            Object.assign(updatedPagination, { perPage: per, page })
            dispatch('saveLocalForagePagination', { promotions: per })
            commit('SET_PROMOGROUPS_PAGINATION', updatedPagination)

            await dispatch('setSubscriptionsSearchQuery')
            const { paramsGroups } = await dispatch('setPromoFilterQueryParams')

            paramsGroups.sort = state.sort.by
            paramsGroups.direction = state.sort.direction

            if (paramsGroups.sort.includes(',')) {
                paramsGroups.direction += `,${paramsGroups.direction}`
            }

            try {
                const { status, data } = await dispatch('fetchPromoGroups', {
                    paramsGroups,
                    pagination: { per, page },
                    ...payload
                })

                commit('SET_PROMOGROUPS_STATUS', 'idle')

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Error GET promo_groups')
                }

                // Set promo groups in store
                const promoGroups = data.data.map(group => {
                    return {
                        ...group,
                        promosStatus: 'idle'
                    }
                })
                commit('SET_PROMOGROUPS', promoGroups)

                // Set groups pagination in store
                const pagination = pagingMap(data.pagination[0])
                commit('SET_PROMOGROUPS_PAGINATION', pagination)

                dispatch('fetchGroupAttachments', {
                    groupId: promoGroups.map(group => group.id).join(),
                    status: 'active'
                })

                // Group expanded by user
                const expandedGroup = await this.$storage.getItem(
                    'expandedGroup'
                )

                const promises = promoGroups.map(group => {
                    if (expandedGroup?.groupId === group.id) {
                        // If there's expanded by user group in local storage, don't fetch it again
                        return dispatch('fetchPromosFromStorageByPromoGroup', {
                            groupId: group.id,
                            resetGroup: false,
                            ...payload
                        })
                    } else {
                        return dispatch('loadPromosByPromoGroup', {
                            per: state.promosLoad.initial,
                            group,
                            'merchant|nip':
                                paramsGroups['promo|subscription|merchant|nip'],
                            ...payload
                        })
                    }
                })

                await Promise.all(promises)

                return promoGroups
            } catch (err) {
                console.log(err)
                commit('SET_PROMOGROUPS_STATUS', 'idle')
            }
        },

        async countPromoGroupsTabs({ state, commit, dispatch }) {
            for (const key in state.count) {
                if (router.currentRoute.name === key) {
                    commit('SET_PROMOGROUPS_COUNT', {
                        [key]: +state.pagination.totalRecords
                    })
                } else {
                    const { paramsGroups } = await dispatch(
                        'setPromoFilterQueryParams',
                        {
                            promoState: key
                        }
                    )

                    let totalRecords = null

                    const res = await dispatch('fetchPromoGroups', {
                        paramsGroups,
                        pagination: { per: 1 }
                    })

                    if (res.data?.pagination) {
                        totalRecords = +res.data.pagination[0].totalRecords
                    }

                    commit('SET_PROMOGROUPS_COUNT', {
                        [key]: totalRecords
                    })
                }
            }
        },

        async fetchPromosByGroupId(_, payload) {
            const { noCancel, ...params } = payload
            const groupId = params.promo_group_id

            if (router.currentRoute.name === 'promo-finished') {
                delete params.promo_group_id

                params['_group[1][promo_group_id]'] = groupId
                params['_group[2][promo_group_id]'] = groupId
                params['_group[3][promo_group_id]'] = groupId
            }

            const res = await this.$api.get('promos', {
                params,
                config: {
                    noCancel: noCancel !== undefined ? noCancel : true
                }
            })

            return res
        },

        async fetchAttachmentsByPromoId(_, payload) {
            const { promo_id, merchant_network_id } = payload

            const merchantNetworkIds = merchant_network_id
                ? 'nil,' + merchant_network_id.toString()
                : null

            const { data } = await this.$api.get('/promo_attachments', {
                params: {
                    promo_id,
                    merchant_network_id: merchantNetworkIds,
                    includes: 'attachment'
                },
                config: {
                    noCancel: true
                }
            })

            return (
                data?.data.map(el => ({
                    promo_id: el.promo_id,
                    attachment: el.attachment
                })) || []
            )
        },

        async fetchPromosFromStorageByPromoGroup(
            { commit, dispatch },
            payload
        ) {
            const expandedGroup = await this.$storage.getItem('expandedGroup')

            if (expandedGroup) {
                const now = moment(new Date())
                const saveTime = moment(expandedGroup.saveTime)
                const duration = moment.duration(now.diff(saveTime))

                if (duration.asSeconds() < 600) {
                    commit('SET_PROMOGROUP_PROMOS', {
                        groupId: expandedGroup.groupId,
                        promos: expandedGroup.promos
                    })

                    commit('SET_PROMOGROUP_PAGINATION', {
                        groupId: expandedGroup.groupId,
                        pagination: expandedGroup.pagination
                    })
                    return true
                } else {
                    const per = +expandedGroup.pagination.perPage

                    /**
                     * Since there's no offset parameter in API's pagination, first we need to
                     * divide amount of promos by maximum value which is returned (100)
                     */
                    const hundredsArr = []
                    const hundredsNum = Math.floor(
                        expandedGroup.promos.length / 100
                    )
                    for (let i = 0; i < hundredsNum; i++) {
                        hundredsArr.push(100)
                    }
                    const hundredsPromises = await hundredsArr.map(
                        async (per, idx) => {
                            return await dispatch('loadPromosByPromoGroup', {
                                group: expandedGroup,
                                per,
                                page: idx + 1,
                                ...payload
                            })
                        }
                    )
                    await Promise.all(hundredsPromises)

                    // then fetch all the rest
                    const restArr = []
                    const restNum = expandedGroup.promos.length % 100
                    const divideRest = restNum / per
                    const pages = (hundredsNum * 100) / per
                    for (let i = 0; i < divideRest; i++) {
                        restArr.push(per)
                    }

                    const restPromises = await restArr.map(async (per, idx) => {
                        return await dispatch('loadPromosByPromoGroup', {
                            group: expandedGroup,
                            per,
                            page: pages + idx + 1,
                            ...payload
                        })
                    })

                    await Promise.all(restPromises)
                    return true
                }
            }
        },
        async toggleWeightPromos({ commit, dispatch, getters }, payload) {
            try {
                const { group } = payload
                const promosWeight = !group.promosWeight

                // set loader
                const sGroups = getters.getSelectedPromoGroupsJson
                const sGroup = sGroups.find(g => g.id === group.id)
                sGroup.loaderNoEans = true
                sGroup.promosWeight = promosWeight
                commit('SELECT_PROMOGROUP', sGroups)

                const promoIdsToFetch = getters.getGroupUnloadedNoEanPromoIds(
                    group
                )

                let promos
                if (promosWeight && promoIdsToFetch.length) {
                    promos = await dispatch('loadSelectedPromos', {
                        group: payload.group,
                        mainCollection: false,
                        per: 99999,
                        params: {
                            id: promoIdsToFetch.join(',')
                        }
                    })
                }
                const promoGroups = promos || getters.getSelectedPromoGroups

                const selectedGroups = await JSON.parse(
                    JSON.stringify(promoGroups)
                )
                const selectedGroup = selectedGroups.find(
                    group => group.id === payload.group.id
                )
                selectedGroup.promosWeight = promosWeight
                selectedGroup.loaderNoEans = false
                commit('SELECT_PROMOGROUP', selectedGroups)
            } catch (err) {
                console.log(err)
            }
        },

        async fetchAndConcatPromos(
            { state, dispatch, getters },
            {
                groups,
                group,
                params,
                per,
                page = 1,
                selected,
                selectedToGenerateLabels,
                subState,
                equalPrices
            }
        ) {
            try {
                if (
                    +group.pagination?.perPage === state.promosLoad.initial &&
                    +per === state.promosLoad.big
                ) {
                    page = 1
                }

                const res = await dispatch('fetchPromosByGroupId', {
                    ...params,
                    sort: 'priority,published_at',
                    direction: 'desc,desc',
                    page,
                    per,
                    promo_group_id: group.id,
                    includes: 'company,company.logo,logo'
                })

                if (!res.data?.data) return

                const cPromos = await dispatch('fetchSubsInNewPromos', {
                    group,
                    fetchedPromos: res.data.data,
                    page,
                    per,
                    selected,
                    equalPrices,
                    subState:
                        subState || getters.getSubscriptionsSearchQuery?.state,
                    selectedToGenerateLabels
                })
                let groupsCopy = JSON.parse(JSON.stringify(groups))

                groupsCopy = groupsCopy.map(g => {
                    if (g.id === group.id) {
                        return {
                            ...g,
                            promos: cPromos
                        }
                    }
                    return g
                })

                const promosPagination = res.data?.pagination?.[0] || {}
                return {
                    groups: groupsCopy,
                    pagination: promosPagination
                }
            } catch (err) {
                console.log(err)
            }
        },

        async loadSelectedPromos({ commit, dispatch, getters }, payload) {
            const { group } = payload

            try {
                commit('SET_PROMOGROUP_STATUS', {
                    groupId: group.id,
                    status: 'loading'
                })
                const { groups, pagination } = await dispatch(
                    'fetchAndConcatPromos',
                    {
                        ...payload,
                        groups: getters.getSelectedPromoGroups,
                        selected: true
                    }
                )

                commit('SELECT_PROMOGROUP', groups)
                if (payload.mainCollection === false) return groups

                commit('SET_SELECTED_PROMOGROUP_PAGINATION', {
                    groupId: group.id,
                    pagination
                })
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_PROMOGROUP_STATUS', {
                    groupId: group.id,
                    status: 'idle'
                })
            }
        },

        async fetchSubsInNewPromos({ dispatch }, payload) {
            const { group, fetchedPromos, equalPrices = true } = payload
            const { selected, selectedToGenerateLabels } = payload
            const { mainCollection, isMainPromo } = payload

            // Get new promos only
            const newPromos = await dispatch('takeNewPromos', {
                group,
                fetchedPromos
            })

            // Set new promos selected statuses and other properties
            newPromos.forEach(promo => {
                const ownMix = promo.product_sets
                promo.selected = selected ?? promo.selected
                promo.selectedToGenerateLabels =
                    selectedToGenerateLabels ?? promo.selectedToGenerateLabels
                promo.marketingPromoConflict = false
                promo.groupId = group.id
                promo.productsStatus = 'idle'
                promo.productsPagination = null
                promo.products = []
                promo.product_sets = []
                promo.own_mix_product_sets = ownMix || []
                promo.main_set =
                    mainCollection !== undefined ? isMainPromo : true
                promo.attachment = promo.attachments?.[0] || null
            })

            // Fetch subscriptions for new promos
            const promosWithSubs = await dispatch(
                'fetchSubscriptionsByPromoId',
                {
                    noCancel: true,
                    promos: newPromos,
                    state: payload.subState,
                    selected,
                    equalPrices
                }
            )

            // If there are new promos, set tooltip info
            if (promosWithSubs.length) {
                dispatch('setTooltipInfoToClosedGroup', {
                    group,
                    promoGroupPromos: promosWithSubs
                })
            }

            // Return concatenated new promos with existing ones
            return await dispatch('concatPromos', {
                mainCollection:
                    mainCollection !== undefined ? isMainPromo : true,
                group,
                newPromos: promosWithSubs,
                apiPromos: fetchedPromos
            })
        },

        async loadPromosByPromoGroup({ commit, dispatch, getters }, payload) {
            const { paramsPromos } = await dispatch('setPromoFilterQueryParams')
            const { group, per, params } = payload
            const groupId = group.id

            // Set group promos status to loading
            group.promosStatus = 'loading'
            commit('SET_PROMOGROUP', group)

            const areFiltersApplied = getters.arePromoFiltersApplied(
                'getPromotionsFilters'
            )

            try {
                if (!group.countPromos && areFiltersApplied) {
                    /**
                     * If there are filters applied, we need to count promos in group.
                     * If filters are not applied, we take count from next request
                     * in order to avoid additional request
                     */
                    const { data } = await dispatch('fetchPromosByGroupId', {
                        promo_group_id: groupId,
                        per: 1,
                        page: 1,
                        state: paramsPromos.state,
                        'subscription|state':
                            paramsPromos['subscription|state'],
                        'subscription|merchant_id':
                            paramsPromos['subscription|merchant_id']
                    })

                    if (!data?.pagination) {
                        return
                    }

                    const pagination = pagingMap(data.pagination[0])
                    group.countPromos = pagination.totalRecords
                }

                // Build payload for promos request
                let includes = 'company,company.logo,logo,attachments'
                if (+groupId === +process.env.VUE_APP_OWN_GROUP_ID) {
                    includes += ',product_sets'
                }

                // Determine the page (priority: payload.page, then pagination.nextPage, default 1)
                const page = payload.page || group.pagination?.nextPage || 1

                const { status, data } = await dispatch(
                    'fetchPromosByGroupId',
                    {
                        ...params,
                        ...paramsPromos,
                        page,
                        promo_group_id: groupId,
                        per,
                        includes
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Error GET promos')
                }

                let promos = data.data
                const pagination = pagingMap(data.pagination[0])

                // If filters are not applied, set count
                if (!areFiltersApplied) {
                    group.countPromos = pagination.totalRecords
                }

                // Fetch promos segments, set smokingSegment
                promos = await dispatch('getPromosSmokingSegments', promos)

                // Fetch promo salesTargetThresholds for SALES_TARGET promo
                const promoIds = promos.filter(promo => {
                    return promo.type === PROMO_TYPES.SALES_TARGET && !promo.salesTargetThresholds
                }).map(el => el.id)

                if (promoIds.length) {
                    promos = await dispatch('loadPromoGroupSalesTargetThresholds', {
                        promoId: promoIds.toString(),
                        groupId: groupId,
                        promos,
                        per: 99999
                    })
                }

                // Concatenated new promos with existing ones
                promos = await dispatch('fetchSubsInNewPromos', {
                    ...payload,
                    group,
                    fetchedPromos: promos
                })

                commit('SET_PROMOGROUP_PROMOS', {
                    groupId,
                    promos,
                    resetGroup: true
                })
                commit('SET_PROMOGROUP_PAGINATION', {
                    groupId,
                    pagination
                })
            } catch (err) {
                console.log(err)
            } finally {
                // Set group promos status to idle
                group.promosStatus = 'idle'
                commit('SET_PROMOGROUP', group)
            }
        },
        concatPromos(_, { mainCollection, group, newPromos }) {
            // Combine existing promos with new promos
            let promos = [...group.promos, ...newPromos]

            // Filter unique promos by id
            promos = promos.filter(
                (promo, index, self) =>
                    self.findIndex(p => p.id === promo.id) === index
            )

            // If it's the main collection, mark all promos as main_set
            if (mainCollection) {
                promos = promos.map(promo => ({
                    ...promo,
                    main_set: true
                }))
            }

            return promos
        },

        takeNewPromos(_, { group, fetchedPromos }) {
            const { promos } = group

            return fetchedPromos.filter(promo => {
                const existingPromo = promos.find(({ id }) => id === promo.id)

                // if promo is not in group or promo is in group but details are not fetched
                return !existingPromo || existingPromo.promoDetailsNotFetched
            })
        },

        setTooltipInfoToClosedGroup({ state, commit }, payload) {
            const { group, promoGroupPromos } = payload
            if (group?.acceptance === 'all') {
                const groupId = payload.groupId

                const interruptedSubs = promoGroupPromos[0].subscriptions.filter(
                    el => {
                        return (
                            el.state === 'interrupted' &&
                            moment().isSame(new Date(el.updated_at), 'day')
                        )
                    }
                )
                const someSubsInterrupted = interruptedSubs.length > 0

                const allSubsInterrupted =
                    interruptedSubs.length ===
                    promoGroupPromos[0].subscriptions.length

                const someSubsAvailable = promoGroupPromos[0].subscriptions.some(
                    el => el.state === 'available'
                )

                if (someSubsInterrupted && !someSubsAvailable) {
                    const newGroupsState = state.promoGroups.map(group => {
                        if (group.id === groupId) {
                            let tooltipInfo
                            group.selectWholeGroupButtonEnable = false
                            if (allSubsInterrupted) {
                                // eslint-disable-next-line max-len
                                tooltipInfo = 'Wszystkie promocje w grupie zostały anulowane. Ponowna aktywacja promocji będzie możliwa jutro.'
                            } else {
                                // eslint-disable-next-line max-len
                                tooltipInfo = 'Grupa promocji została anulowana w co najmniej jednym sklepie. Ponowna aktywacja promocji będzie możliwa jutro.'
                            }
                            group.groupButtonTooltipInfo = tooltipInfo
                        }
                        return group
                    })
                    commit('SET_PROMOGROUPS', newGroupsState)
                }
            }
        },

        async fetchProductsByPromoId({ state, commit, getters }, payload) {
            const { params, promo, productSetId, promoDictProductId } = payload
            const promotion = JSON.parse(JSON.stringify(promo))
            const shouldFetchSets = getters.hasProductSets(promo.type)

            if (shouldFetchSets) {
                let setsData = promotion.product_sets || promotion.productSets

                let productSetsIds = productSetId ? [productSetId] : undefined

                if (!productSetsIds) {
                    const resSets = await this.$api.get('product_sets', {
                        params,
                        config: {
                            noCancel: true
                        }
                    })
                    setsData = resSets.data.data?.map(set => {
                        return {
                            ...set,
                            product_set_dict_products: [],
                            pagination: null
                        }
                    })
                    productSetsIds = setsData?.map(set => set.id)
                }

                for (const setId of productSetsIds) {
                    const resProducts = await this.$api.get(
                        'product_set_dict_products',
                        {
                            params: {
                                ...params,
                                includes: 'dict_product,dict_product.image',
                                product_set_id: setId,
                                promo_dict_product_id:
                                    promoDictProductId ||
                                    params.promo_dict_product_id
                            },
                            config: {
                                noCancel: true
                            }
                        }
                    )

                    const findSet = setsData.find(set => set.id === setId)
                    if (findSet) {
                        if (!promoDictProductId) {
                            findSet.product_set_dict_products =
                                resProducts.data.data
                            findSet.pagination = resProducts.data.pagination[0]
                        } else {
                            findSet.product_set_dict_products.push(
                                ...resProducts.data.data
                            )
                        }
                    }
                }

                return setsData
            } else {
                const resData = await this.$api.get('products', {
                    params: {
                        ...params,
                        includes:
                            'dict_product,dict_product.image,dict_product.dict_product_type'
                    },
                    config: {
                        noCancel: true
                    }
                })
                return resData
            }
        },
        async fetchProductsByPromoGroupPromo(
            { state, commit, getters, dispatch },
            payload
        ) {
            const searchedPromoByGroup = getPromoGroupPromo(state, payload)
            const searchedSelectedPromo = state.selectedPromoGroups
                ?.find(group => group.id === payload.groupId)
                ?.promos?.find(promo => promo.id === payload.promoId)

            const firstTimeLoad =
                searchedSelectedPromo?.firstTimeLoad === undefined
                    ? true
                    : searchedSelectedPromo.firstTimeLoad

            const fromSelectedGroups =
                payload.fromSelectedGroups ||
                payload.previewType === 'group-accept'

            const searchedPromo = fromSelectedGroups
                ? searchedSelectedPromo
                : searchedPromoByGroup

            const areSubscriptionProducts =
                searchedSelectedPromo?.subscriptions[0]?.products
            const shouldNotReturn =
                fromSelectedGroups && !areSubscriptionProducts

            const productSet = searchedPromo.product_sets?.find(
                s => s.id === payload.productSetId
            )

            const productsPagination =
                productSet?.pagination || searchedPromo.productsPagination

            if (searchedSelectedPromo && firstTimeLoad) {
                if (searchedPromo.type.includes('Weight')) {
                    await dispatch('setPromotionEqualLocalCodes', {
                        ...payload,
                        val: false,
                        previewType: 'group-accept'
                    })
                    dispatch('setPromotionEqualPrice', {
                        ...payload,
                        val: false,
                        previewType: 'group-accept'
                    })
                } else {
                    dispatch('setPromotionEqualPrice', {
                        ...payload,
                        val: true,
                        previewType: 'group-accept'
                    })
                }
            }

            let shouldReturn = false
            if (payload.main && productsPagination?.nextPage === '') {
                shouldReturn = true
            }

            if (shouldNotReturn) {
            } else if (shouldReturn) {
                return
            }

            const arePromoSets = getters.hasProductSets(searchedPromo?.type)

            commit('SET_PROMOGROUP_PROMO_PRODUCTS_STATUS', {
                promoId: payload.promoId,
                groupId: payload.groupId,
                status: 'loading',
                productSetId: payload.productSetId
            })

            let page = payload.page
            let reset = false
            if (!page) {
                page = productsPagination?.nextPage
                    ? productsPagination?.nextPage
                    : 1

                if (
                    payload.main &&
                    payload.per &&
                    +productsPagination?.perPage !== +payload.per
                ) {
                    page = 1
                    reset = true
                }
            }

            return dispatch('fetchProductsByPromoId', {
                params: {
                    main: payload.main === undefined ? true : payload.main,
                    page,
                    per: payload.per,
                    promo_id: payload.promoId,
                    promo_dict_product_id: payload.promoDictProductId
                },
                promo: searchedPromo,
                productSetId: payload.productSetId
            })
                .then(res => {
                    if (payload.promoDictProductId) {
                        reset = false
                    }
                    if (
                        (arePromoSets && res) ||
                        (!arePromoSets && res.status === 200)
                    ) {
                        const data = arePromoSets ? res : res.data.data
                        const pagination = arePromoSets
                            ? res[0].pagination
                            : res.data.pagination[0]

                        commit('SET_PROMOGROUP_PROMO_PRODUCTS', {
                            promoId: payload.promoId,
                            groupId: payload.groupId,
                            products: !arePromoSets ? data : null,
                            productsSetData: arePromoSets ? data : null,
                            productSetId: payload.productSetId,
                            pagination: payload.main ? pagination : undefined,
                            selectedGroups: fromSelectedGroups,
                            reset
                        })
                        dispatch('setGroupPromoSubscriptions', {
                            ...payload,
                            copyOnlySelectedSubs: !!getters.modalState?.args
                                ?.singleSubscription,
                            firstTimeLoad
                        })

                        return data
                    }
                })
                .catch(err => console.log(err))
                .finally(() => {
                    commit('SET_PROMOGROUP_PROMO_PRODUCTS_STATUS', {
                        promoId: payload.promoId,
                        groupId: payload.groupId,
                        status: 'idle',
                        productSetId: null
                    })
                    return true
                })
        },
        setPromoGroupsSort({ commit }, payload) {
            commit('SET_PROMOGROUPS_SORT', payload)
        },
        async selectPromoGroup({ commit, dispatch, getters }, payload) {
            let selectedGroups = getters.getSelectedPromoGroupsJson
            const selectedGroup = selectedGroups.find(
                group => group.id === payload.groupId
            )
            const promoGroups = getters.getPromoGroupsJson
            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )

            if (promoGroup) {
                promoGroup.showPromosOnAcceptView = false
                promoGroup.showMerchantsOnAcceptView = false
            }

            let fetchedPromoIds = []
            let fetchedNoEanPromoIds = []
            if (
                !getters.arePromoFiltersApplied('getPromotionsFilters') &&
                !payload.select
            ) {
                fetchedPromoIds = []
                fetchedNoEanPromoIds = []
            } else if (!payload.select && selectedGroup) {
                fetchedPromoIds = selectedGroup.selectedPromoIds || []
                fetchedNoEanPromoIds = selectedGroup.selectedNoEanPromoIds || []
            } else {
                let { paramsPromos: params } = await dispatch(
                    'setPromoFilterQueryParams'
                )
                params = { ...params, ...payload.params }

                if (promoGroup.acceptance === 'all') {
                    // if group is closed, fetch only allowed params
                    const allowedParams = [
                        'state',
                        'subscription|state',
                        'subscription|merchant_id',
                        'sort',
                        'direction'
                    ]

                    params = Object.keys(params)
                        .filter(key => allowedParams.includes(key))
                        .reduce((obj, key) => {
                            obj[key] = params[key]
                            return obj
                        }, {})
                }

                const { promoIds, noEanPromoIds } = await dispatch(
                    'fetchSelectedPromoIds',
                    {
                        group: promoGroup,
                        params,
                        commitName: 'SET_PROMOGROUP_STATUS'
                    }
                )
                fetchedPromoIds = promoIds
                fetchedNoEanPromoIds = noEanPromoIds
            }

            // if group is already selected
            if (selectedGroup) {
                if (payload.select) {
                    // select whole group when at least one promo is selected
                    selectedGroup.promos.forEach(promo => {
                        promo.selected = true
                    })

                    selectedGroup.selectedPromoIds = [
                        ...new Set([
                            ...fetchedPromoIds,
                            ...selectedGroup.selectedPromoIds
                        ])
                    ]
                    selectedGroup.selectedNoEanPromoIds = [
                        ...new Set([
                            ...fetchedNoEanPromoIds,
                            ...selectedGroup.selectedNoEanPromoIds
                        ])
                    ]
                    selectedGroup.selectWholeGroup = true
                } else {
                    // if group is already selected and we want to deselect it
                    // if filters are not applied, deselect whole group
                    if (
                        !getters.arePromoFiltersApplied('getPromotionsFilters')
                    ) {
                        selectedGroup.promos.forEach(promo =>
                            commit('RESET_PROMOGROUP_PRODUCTS_PAGINATION', {
                                ...payload,
                                promoId: promo.id,
                                selected: true
                            })
                        )
                        // remove group
                        selectedGroups = selectedGroups.filter(
                            group => group.id !== payload.groupId
                        )

                        // if filters are applied, deselect only selected promos
                    } else {
                        selectedGroup.selectWholeGroup = false

                        fetchedPromoIds.forEach(promoId => {
                            const promo = selectedGroup.promos.find(
                                promo => promo.id === promoId
                            )

                            if (promo) {
                                promo.selected = false
                                commit('RESET_PROMOGROUP_PRODUCTS_PAGINATION', {
                                    ...payload,
                                    promoId: promo.id,
                                    selected: true
                                })
                            }

                            selectedGroup.selectedPromoIds =
                                selectedGroup.selectedPromoIds.filter(
                                    id => id !== promoId
                                )
                            selectedGroup.selectedNoEanPromoIds =
                                selectedGroup.selectedNoEanPromoIds.filter(
                                    id => id !== promoId
                                )
                        })

                        if (!selectedGroup.selectedPromoIds.length) {
                            // remove group
                            selectedGroups = selectedGroups.filter(
                                group => group.id !== payload.groupId
                            )
                        }
                    }
                }
                // if group is not selected yet
            } else {
                if (payload.selectOnlyOnePromo) {
                    // select single promo
                    const promo = promoGroup.promos.find(
                        promo => promo.id === payload.promoId
                    )
                    promo.subscriptions.forEach(sub => {
                        sub.products = []
                    })

                    promo.subscriptionsEqualPrices.priceGroups.forEach(
                        priceGroup => {
                            priceGroup.forEach(sub => {
                                sub.products = []
                            })
                        }
                    )
                    promo.productsPagination = null
                    promo.showMore = false
                    promo.selected = true

                    selectedGroups.push({
                        ...promoGroup,
                        selectedPromoIds: [promo.id],
                        selectedNoEanPromoIds:
                            !promo.all_eans_present &&
                            !getters.hasProductSets(promo.type)
                                ? [promo.id]
                                : [],
                        selectWholeGroup: false
                    })
                } else {
                    // select whole group
                    promoGroup.promos.forEach(promo => {
                        promo.selected = true
                    })
                    selectedGroups.push({
                        ...promoGroup,
                        selectedPromoIds: fetchedPromoIds,
                        selectedNoEanPromoIds: fetchedNoEanPromoIds,
                        selectWholeGroup: true
                    })
                }
            }

            commit('SELECT_PROMOGROUP', selectedGroups)
            return selectedGroups
        },
        async selectPromoGroupPromo({ state, commit, dispatch }, payload) {
            let selectedGroups = state.selectedPromoGroups
            const searchedGroup = selectedGroups.find(
                group => group.id === payload.groupId
            )
            if (payload.acceptance === 'all') {
                if (payload.addPromoWholeGroup) {
                    selectedGroups = await dispatch('selectPromoGroup', {
                        groupId: payload.groupId,
                        select: payload.select,
                        fromPromoDetails: payload.fromPromoDetails,
                        params: payload.params
                    })
                    dispatch('toggleModal', false)
                } else {
                    dispatch('openModal', {
                        component: 'AcceptanceAllGroupModal',
                        args: payload
                    })
                }
                return
            } else if (!searchedGroup) {
                // if group is not selected yet, select it with only this promo selected
                selectedGroups = await dispatch('selectPromoGroup', {
                    select: true,
                    selectOnlyOnePromo: true,
                    groupId: payload.groupId,
                    promoId: payload.promoId,
                    fromPromoDetails: payload.fromPromoDetails,
                    params: payload.params
                })
            } else {
                // select promotion
                let searchedPromo = searchedGroup.promos.find(
                    promo => promo.id === payload.promoId
                )

                if (!searchedPromo) {
                    const sGroupPromoIds = searchedGroup.promos.map(p => p.id)
                    const promos = state.promoGroups
                        .find(g => g.id === payload.groupId)
                        .promos.filter(p => !sGroupPromoIds.includes(p.id))
                    searchedGroup.promos.push(...promos)

                    searchedPromo = searchedGroup.promos.find(
                        promo => promo.id === payload.promoId
                    )
                }

                if (searchedPromo) {
                    searchedPromo.selected = payload.select

                    searchedPromo.subscriptions.forEach(sub => {
                        sub.products = []
                    })

                    searchedPromo.subscriptionsEqualPrices.priceGroups.forEach(
                        priceGroup => {
                            priceGroup.forEach(sub => {
                                sub.products = []
                            })
                        }
                    )
                    searchedPromo.productsPagination = null
                    searchedPromo.showMore = false
                }

                if (payload.select) {
                    searchedGroup.selectedPromoIds = [
                        ...new Set([
                            ...searchedGroup.selectedPromoIds,
                            ...[payload.promoId]
                        ])
                    ]

                    if (!searchedPromo.all_eans_present) {
                        searchedGroup.selectedNoEanPromoIds = [
                            ...new Set([
                                ...searchedGroup.selectedNoEanPromoIds,
                                ...[payload.promoId]
                            ])
                        ]
                    }
                } else {
                    commit('RESET_PROMOGROUP_PRODUCTS_PAGINATION', {
                        ...payload,
                        selected: true
                    })
                    searchedGroup.selectedPromoIds = searchedGroup.selectedPromoIds.filter(
                        id => id !== payload.promoId
                    )

                    if (!searchedPromo.all_eans_present) {
                        searchedGroup.selectedNoEanPromoIds =
                            searchedGroup.selectedNoEanPromoIds.filter(
                                id => id !== payload.promoId
                            )
                    }
                }

                if (searchedGroup.selectedPromoIds.length === 0) {
                    selectedGroups = selectedGroups.filter(
                        group => group.id !== payload.groupId
                    )
                }
            }

            commit('SELECT_PROMOGROUP', selectedGroups)
            return selectedGroups
        },
        selectGroupMerchant({ state, commit, dispatch }, payload) {
            const groupMerchants = state.selectedPromoGroups.find(
                group => group.id === payload.groupId
            ).merchantIds

            if (!groupMerchants) return

            const merchant = groupMerchants.find(
                el => el.id === payload.merchantId
            )

            if (payload.value !== undefined) {
                merchant.selected = payload.value
            } else {
                merchant.selected
                    ? (merchant.selected = false)
                    : (merchant.selected = true)
            }
            commit('SET_PROMOGROUP_MERCHANTS', {
                groupId: payload.groupId,
                merchantIds: groupMerchants
            })
            dispatch('changeSubCheckedToAllGroupPromos', {
                groupId: payload.groupId
            })
        },
        async selectGroupMerchants(
            { state, commit, dispatch, getters },
            payload
        ) {
            let group = getters.getSelectedPromoGroup(payload.groupId)
            await dispatch('downloadGroupMerchants', group)
            group = state.selectedPromoGroups.find(
                group => group.id === payload.groupId
            )

            let groupMerchants = group.merchantIds
            groupMerchants = groupMerchants.map(el => {
                return {
                    ...el,
                    selected: el.disabled ? false : payload.value
                }
            })

            commit('SET_PROMOGROUP_MERCHANTS', {
                groupId: payload.groupId,
                merchantIds: groupMerchants
            })
            dispatch('changeSubCheckedToAllGroupPromos', {
                groupId: payload.groupId
            })
        },
        changeSubCheckedToAllGroupPromos({ state, commit }, payload) {
            const selectedGroups = JSON.parse(
                JSON.stringify(state.selectedPromoGroups)
            )
            const group = selectedGroups.find(
                group => group.id === payload.groupId
            )
            const groupMerchants = group.merchantIds

            group.promos.forEach(promo => {
                promo.subscriptions.forEach(sub => {
                    const merchant = groupMerchants.find(
                        merchant => merchant.id === sub.merchant_id
                    )
                    if (merchant) {
                        sub.checked = merchant.selected
                    }
                })
                if (!promo.subscriptionsEqualPrices?.priceGroups) return
                promo.subscriptionsEqualPrices.priceGroups.forEach(
                    priceGroup => {
                        priceGroup.forEach(sub => {
                            const merchant = groupMerchants.find(
                                merchant => merchant.id === sub.merchant_id
                            )
                            if (merchant) {
                                sub.checked = merchant.selected
                            }
                        })
                    }
                )
            })

            commit('SELECT_PROMOGROUP', selectedGroups)
        },
        selectSameMerchantsAsOnPromoDetails({ state, commit }, payload) {
            const selectedGroups = JSON.parse(
                JSON.stringify(state.selectedPromoGroups)
            )
            const group = selectedGroups.find(el => el.id === payload.groupId)
            const promo = group.promos.find(el => el.id === payload.promoId)
            group.merchantIds.forEach(merchant => {
                const sub = promo.subscriptions.find(
                    sub => sub.merchant_id === merchant.id
                )
                if (sub) merchant.selected = !!sub.checked
            })
            commit('SELECT_PROMOGROUP', selectedGroups)
        },
        setPromoGroupsPagination({ state, commit }, payload) {
            const pagination = state.pagination
            const newPagination = {
                ...pagination,
                ...payload
            }
            commit('SET_PROMOGROUPS_PAGINATION', newPagination)
        },
        async handleExpandedGroup({ _ }, payload) {
            const { to: toRoute } = payload
            const expandedGroup = await this.$storage.getItem('expandedGroup')
            if (expandedGroup) {
                if (toRoute.name !== expandedGroup.promoListRoute) {
                    if (
                        toRoute.name === 'promo-details' &&
                        +toRoute.params.id === expandedGroup.promoId
                    ) {
                        return
                    }
                    this.$storage.removeItem('expandedGroup')
                }
            }
        },
        resetPromosInAllPromoGroups({ state, commit, getters }) {
            const promoGroups = getters.getPromoGroups
            promoGroups.forEach(group => {
                if (group.promos.length > 2) {
                    group.promos = group.promos.slice(0, 2)
                    group.pagination = {
                        ...group.pagination,
                        page: 1,
                        perPage: 2,
                        totalPages: group.pagination.totalRecords / 2,
                        prevPage: '',
                        nextPage: group.pagination.totalRecords > 2 ? 2 : ''
                    }
                }
            })
            commit('SET_PROMOGROUPS', promoGroups)
        },

        async fetchGroupAttachments({ state, commit }, payload) {
            try {
                const { status, data } = await this.$api.get(
                    'promo_group_attachments',
                    {
                        params: {
                            promo_group_id: payload.groupId,
                            includes: 'attachment',
                            status: payload.status,
                            per: 99999
                        }
                    }
                )

                if (status !== 200 || !data.data) {
                    throw new Error(
                        data.message || 'Error GET group attachments'
                    )
                }

                data.data.forEach(item => {
                    const id = item.promo_group_id
                    const promoGroup = state.promoGroups.find(e => e.id === id)

                    if (promoGroup) {
                        promoGroup.attachments = promoGroup.attachments || []
                        promoGroup.attachments.push(item)
                    }
                })

                commit('SET_PROMOGROUPS', state.promoGroups)
            } catch (err) {
                console.error(err)
            }
        },

        async downloadAllGroupAttachments(
            { state, commit, dispatch },
            payload
        ) {
            commit('SET_ALL_GROUP_ATTACHMENTS_STATUS', 'loading')
            const response = await this.$api.get(
                'promo_group_attachments_all',
                {
                    responseType: 'arraybuffer',
                    params: payload
                }
            )
            const blob = new Blob([response.data], {
                type: `data:${response.headers['content-type']};base64`
            })
            const fileType = response.headers['content-type'].split('/').pop()

            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${payload.name}.${fileType}`

            // Firefox requires the link to be in the body
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            dispatch('toggleModal', false)
            commit('SET_ALL_GROUP_ATTACHMENTS_STATUS', 'idle')
        },
        async promoGroupTypesFetch({ _ }, payload) {
            try {
                const response = await this.$api.get('/promo_group_types', {
                    params: payload
                })
                return response.data
            } catch (err) {
                console.log(err)
            }
        },
        setUnloadedWeightPromos({ commit }, payload) {
            commit('SET_UNLOADED_WEIGHT_PROMOS', payload)
        },
        setGroup() {},
        updateSelectedGroup({ commit, getters }, payload) {
            const selectedGroups = JSON.parse(
                JSON.stringify(getters.getSelectedPromoGroups)
            )
            const groupIndex = selectedGroups.findIndex(
                el => el.id === payload.id
            )

            if (groupIndex !== -1) {
                selectedGroups[groupIndex] = payload
                return commit('SELECT_PROMOGROUP', selectedGroups)
            }
        },
        async fetchPromoGroupsMerchants({ commit, getters }, payload) {
            try {
                const merchants = await this.$api.get('/merchants', {
                    params: {
                        'subscription|promo|promo_group_id': payload.group.id,
                        'subscription|state':
                            'available,interrupted,incompatible',
                        'subscription|suspended': false,
                        'subscription|promo|state': 'active',
                        per: 99999
                    },
                    config: {
                        noCancel: true
                    }
                })
                return merchants
            } catch (err) {
                console.log(err)
            }
        },
        async fetchSelectedPromoIds({ commit, dispatch }, payload) {
            const { group, params, commitName } = payload
            const groupDownloadedPromos = group.promos
            const groupTotalRecords = group.pagination.totalRecords

            let promos

            if (groupTotalRecords > groupDownloadedPromos.length) {
                commit(commitName, {
                    groupId: group.id,
                    status: 'loading',
                    loadingSelectedPromoIds: true
                })

                let res
                if (
                    group.acceptance === 'all' &&
                    router.currentRoute.name !== 'labels'
                ) {
                    res = await dispatch('fetchPromosByGroupId', {
                        ...params,
                        promo_group_id: group.id,
                        page: 1,
                        per: 99999,
                        state: params.state,
                        'subscription|state': params['subscription|state'],
                        'subscription|merchant_id':
                            params['subscription|merchant_id']
                    })
                } else {
                    res = await dispatch('fetchPromosByGroupId', {
                        ...params,
                        promo_group_id: group.id,
                        page: 1,
                        per: 99999
                    })
                }
                promos = res.data.data

                commit(commitName, {
                    groupId: group.id,
                    status: 'idle',
                    loadingSelectedPromoIds: false
                })
            } else {
                if (group.acceptance === 'all') {
                    const res = await dispatch('fetchPromosByGroupId', {
                        ...params,
                        promo_group_id: group.id,
                        page: 1,
                        per: 99999,
                        state: params.state,
                        'subscription|state': params['subscription|state'],
                        'subscription|merchant_id':
                            params['subscription|merchant_id']
                    })
                    promos = res.data.data
                } else {
                    promos = group.promos
                }
            }

            return {
                promoIds: promos.map(el => el.id),
                noEanPromoIds: promos
                    .filter(el => !el.all_eans_present)
                    .map(el => el.id)
            }
        },

        async setMerchantEansInSelectedPromoGroup(
            { dispatch, commit, getters },
            payload
        ) {
            const { products, promotion, params, config } = payload

            const { data } = await dispatch('fetchMerchantAltEans', {
                params: {
                    'dict_product|id': products
                        .map(product => product.dict_product_id)
                        .join(','),
                    ...params
                },
                config
            })

            const eans = data.data

            if (!eans?.length) return

            const groups = getters.getSelectedPromoGroupsJson
            const promo = groups
                .find(group => group.id === promotion.groupId)
                .promos.find(promo => promo.id === promotion.id)

            eans.forEach(ean => {
                promo.subscriptions.forEach(sub => {
                    if (sub.merchant_id !== ean.merchant_id) return
                    sub.products.forEach(product => {
                        if (product.dict_product_id === ean.dict_product_id) {
                            product.alternativeEan = ean.alternative_ean
                        }
                    })
                })

                promo.subscriptionsEqualPrices.priceGroups.forEach(
                    priceGroup => {
                        priceGroup.forEach(sub => {
                            if (sub.merchant_id !== ean.merchant_id) return
                            sub.products.forEach(product => {
                                if (
                                    product.dict_product_id ===
                                    ean.dict_product_id
                                ) {
                                    product.alternativeEan = ean.alternative_ean
                                }
                            })
                        })
                    }
                )
            })

            commit('SELECT_PROMOGROUP', groups)
        },

        setProductEansErrors({ commit, getters }, payload) {
            let groups
            let commitName
            const promotion = payload.promotion

            if (payload.selected) {
                groups = getters.getSelectedPromoGroupsJson
                commitName = 'SELECT_PROMOGROUP'
            } else {
                groups = getters.getPromoGroupsJson
                commitName = 'SET_PROMOGROUPS'
            }

            const group = groups.find(el => el.id === promotion.promo_group_id)
            const promo = group.promos.find(el => el.id === promotion.id)
            const equalCodes = promo.equalLocalCodes

            let subscriptions = []
            if (!equalCodes) {
                subscriptions = promo.subscriptions.filter(
                    el => el.merchant_id === payload.merchantId
                )
            } else {
                subscriptions =
                    promo.subscriptionsEqualPrices.priceGroups[payload.groupIdx]
            }

            subscriptions.forEach(sub => {
                const products = sub.products || sub.product_subscriptions
                const product = products.find(el => el.id === payload.productId)
                Vue.set(product, 'eanErrors', payload.eanErrors)
            })

            commit(commitName, groups)
        },
        async getPromosSmokingSegments({ dispatch }, promos) {
            try {
                const { data, status } = await this.$api.get(
                    '/promo_segments',
                    {
                        params: {
                            promo_id: promos.map(el => el.id).toString(),
                            segment_name: 'Strefa palacza'
                        },
                        config: {
                            noCancel: true
                        }
                    }
                )

                if (status !== 200 || !data.data) {
                    throw new Error(data.message || 'Error GET promo_segments')
                }

                const promoIds = data.data.map(v => v.promo_id)

                return promos.map(promo => {
                    return {
                        ...promo,
                        smokingSegment: promoIds.includes(promo.id)
                    }
                })
            } catch (error) {
                console.error(error)
                return promos
            }
        },
        async loadPromoGroupSalesTargetThresholds({ commit, dispatch }, payload) {
            const salesTargetThresholds = await dispatch('fetchSalesTargetThresholds', payload)

            if (!salesTargetThresholds) return

            return payload.promos.map(promo => {
                return {
                    ...promo,
                    salesTargetThresholds: salesTargetThresholds.filter(el => el.promo_id === promo.id).slice(0, 5)
                }
            })
        }
    },
    getters: {
        getGroupSelectedSubscriptionProductPrice: (state, getters) => (
            promoId,
            productId,
            merchantId,
            groupIdx = null,
            promoGroupId
        ) => {
            let searchedSubs
            const promo = getPromoGroupPromo(state, {
                groupId: promoGroupId,
                promoId: promoId
            })

            if (groupIdx !== null) {
                searchedSubs =
                    promo.subscriptionsEqualPrices.priceGroups[groupIdx]
            } else {
                searchedSubs = promo.subscriptions
            }

            let searchedProducts
            if (groupIdx !== null) {
                searchedProducts = searchedSubs[0].products
            } else {
                searchedProducts = searchedSubs.find(
                    el => el.merchant_id === merchantId
                ).products
            }
            const searchedProduct = searchedProducts.find(
                el => el.id === productId
            )
            return searchedProduct.productPrice
        },
        getGroupPromotionShopsEqualPrices: state => payload => {
            const promo = getSelectedPromoGroupPromo(state, payload)
            return promo.subscriptionsEqualPrices.priceGroups
        },
        getGroupPromotionShops: state => payload => {
            const promo = getPromoGroupPromo(state, payload)
            return promo.subscriptions.filter(el => el.state === 'available')
        },
        getPromoGroups: state => state.promoGroups,
        getPromoGroupsJson: state =>
            JSON.parse(JSON.stringify(state.promoGroups)),
        getPromoGroupsStatus: state => state.status,
        getPromoGroupsPromosLoad: state => state.promosLoad,
        getPromoGroupsPagination: state => state.pagination,
        getPromoGroupsSort: state => state.sort,
        getPromoGroupsSortOptions: state =>
            state.sortOptions.map(e => Object.assign(e)),
        getSelectedPromoGroups: state => state.selectedPromoGroups,
        getSelectedPromoGroupsJson: state =>
            JSON.parse(JSON.stringify(state.selectedPromoGroups)),
        getPromoGroup: state => id => {
            return state.promoGroups.find(group => group.id === id)
        },
        getSelectedPromoGroup: state => id => {
            return state.selectedPromoGroups.find(group => group.id === id)
        },
        getSelectedPromoGroupPromo: state => (promoId, groupId) => {
            const group = state.selectedPromoGroups.find(
                group => group.id === groupId
            )
            if (group) {
                const promo = group.promos.find(promo => promo.id === promoId)
                if (promo) return promo.selected
                else return false
            } else {
                return false
            }
        },
        getSelectedPromoGroupPromoItem: state => ({ promoId, groupId }) => {
            let promo = null
            const group = state.selectedPromoGroups.find(
                group => group.id === groupId
            )
            if (group) {
                promo = group.promos.find(promo => promo.id === promoId)
            }

            return promo
        },
        getPromoGroupPromo: state => (promoId, groupId) => {
            const group = state.promoGroups.find(group => group.id === groupId)
            if (group) {
                return group.promos.find(promo => promo.id === promoId)
            }
        },
        getPromoProductsByMerchantId: (state, getters) => (
            promoId,
            groupId,
            merchantId
        ) => {
            const promo = getters.getPromoGroupPromo(promoId, groupId)
            const subscription = promo.subscriptions.find(
                el => el.merchant_id === merchantId
            )
            const products = subscription.product_subscriptions.map(product => {
                return {
                    price: product.price
                }
            })
            return products
        },
        getWalkthroughModalPromoAcceptStep: state =>
            state.walkthroughModalPromoAcceptStep,

        getAllGroupAttachmentsStatus: state => state.allGroupAttachmentsStatus,

        getUnloadedWeightPromos: state => state.unloadedWeightPromos,

        getGroupUnloadedNoEanPromoIds: state => group => {
            const unloadedPromos = []

            if (!group) return unloadedPromos

            const groupSelectedPromoIds = group.promos
                .filter(el => el.selected)
                .map(el => el.id)

            for (const noEanPromoId of group.selectedNoEanPromoIds) {
                if (!groupSelectedPromoIds.includes(noEanPromoId)) {
                    unloadedPromos.push(noEanPromoId)
                }
            }

            return unloadedPromos
        },

        isPromoTypeWeight: state => promo => promo.type.includes('Weight'),

        getSelectedPromotions: state => {
            const promotions = []
            for (const group of state.selectedPromoGroups) {
                for (const promo of group.promos) {
                    if (promo.selected) {
                        promotions.push(promo)
                    }
                }
            }
            return promotions
        },
        getLocalCodesValidation: state => state.localCodesValidation,
        arePromoFiltersApplied: (state, getters) => getter => {
            const filters = getters[getter]
            const filterNames = [
                'activePromos',
                'promo|subscriptions_auto_acceptance',
                'endingPromos',
                'newPromos',
                'promo|company_id',
                'promo|query',
                'promo|type',
                'startingPromos'
            ]

            let areApplied = false
            for (const key of filterNames) {
                if (filters[key]) {
                    if (Array.isArray(filters[key].value)) {
                        if (filters[key].value.length > 0) {
                            areApplied = true
                            break
                        }
                    } else if (filters[key].value) {
                        areApplied = true
                        break
                    }
                }
            }
            return areApplied
        },
        getPromotionsCount: state => state.count,
        getActivePromosDownloadStatus: state => state.activePromosDownloadStatus
    }
}
